<script>
import { storedSprints, filters, sprintSort, sprintFilter, getStatus, Status } from '../data/sprints';
import { publicSprints } from '../data/server';
import { minute } from '../data/datetime';
import Hero from './Hero.svelte';
import SprintListItem from './SprintListItem.svelte';

const emptyArray = [];
const mySprints = createMySprintsStore(user);
let remoteSprints = emptyArray;

$: sprints = combineSprints($storedSprints, $mySprints, $publicSprints);
$: filteredSprints = sprintFilter(sprints, $filters, $minute);


function combineSprints(storedSprints, mySprints, remoteSprints) {
	const byId = {};
	mySprints.forEach(sprint => byId[sprint.id] = sprint);
	remoteSprints.forEach(sprint => byId[sprint.id] = sprint);
	storedSprints.forEach(sprint => {
		if (byId[sprint.id]) {
			byId[sprint.id] = mergeSprints(byId[sprint.id], sprint);
		} else {
			byId[sprint.id] = sprint;
		}
	});
	const sprints = Object.values(byId);
	return sprints.length ? sprints.sort(sprintSort) : emptyArray;
}

function mergeSprints(remote, local) {
	Object.keys(local).forEach(key => {
		if (!remote.hasOwnProperty(key)) remote[key] = local[key];
	});
	return remote;
}
</script>

<!-- <Hero/> -->
<section>
  <div class="sprint-list">
    <div class="create">
      <a class="btn primary small" href="/">Create a sprint</a>
    </div>
    <div class="sprints-header">
      <h2>Sprints</h2>
      {#if sprints.length}
      <span class="filter-label">Show:</span>
      <button class="btn xs" class:untoggled={!$filters.finished} on:click={() => filters.toggle('finished') }>Finished</button>
      <button class="btn xs" class:untoggled={!$filters.personal} on:click={() => filters.toggle('personal') }>Personal</button>
      <button class="btn xs" class:untoggled={!$filters.group} on:click={() => filters.toggle('group') }>Group</button>
      {/if}
    </div>
    <div class="sprints">
    {#if filteredSprints.length}
      {#each filteredSprints as sprint}
      <SprintListItem {sprint}/>
      {/each}
    {:else}
      <div class="no-sprints">
        {#if !sprints.length}
        There are no sprints. <a href="/">Create your own!</a>
        {:else}
        There are no sprints matching these filters. <a href="/">Create a new one!</a>
        {/if}
      </div>
    {/if}
    </div>
  </div>
</section>

<style>
.sprint-list {
	max-width: 660px;
}
.create {
  display: flex;
  justify-content: flex-end;
  margin: 12px 0 24px;
}
.sprints-header {
	display: flex;
	align-items: baseline;
  margin: 12px 0 24px;
  color: var(--warm-grey-700);
}
.sprints-header .btn {
	margin-left: 4px;
}
.sprints-header h2 {
	flex: 1;
	margin: 0;
}
.filter-label {
	font-size: var(--font-size-050);
	color: var(--warm-grey-500);
	margin-right: 4px;
}
.no-sprints {
	color: var(--warm-grey-500);
	padding: 12px;
  border-radius: 4px;
	border: 1px dashed var(--warm-grey-200);
}
@media (max-width: 660px) {
	.sprint-list h2 {
		font-size: var(--font-size-600);
	}
}
</style>
